var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-full main_out"},[_c('sidebar',{staticClass:"app-sidebar"}),_c('navbar',{staticClass:"app-navbar"}),_c('div',{staticClass:"tags-nav-out"},[_c('tags-nav',{attrs:{"value":_vm.$route,"list":_vm.tagNavList},on:{"input":_vm.handleClick,"on-close":_vm.handleCloseTag}})],1),_c('app-main',{staticClass:"app-main"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }